export class UpscopeController
{
    private _isInitialized:boolean = false;

    public init():void
    {
        if( this.isInitialized() )
            return;

        // below is a code snipped copied from upscope. It's not modified aside from formatting and typing.
        (function(w, u, d)
        {
            var i = function()
            {
                i.c(arguments);
            } as any;
            i.q = [];
            i.c = function(args)
            {
                i.q.push(args);
            };
            var l = function()
            {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://code.upscope.io/qT6dpPR8Ug.js';
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if( typeof u !== 'function' )
            {
                (w as any).Upscope = i;
                l();
            }
        })(window, (window as any).Upscope, document);

        const Upscope = (window as any).Upscope;

        Upscope('init');
        Upscope('updateConnection', {
            uniqueId: '',
            identities: []
        });

        this._isInitialized = true;
    }

    public isInitialized():boolean
    {
        return this._isInitialized;
    }
}
